import { ColScaffold, EMPTY_SCAFFOLD_SELECTION, ScaffoldSelection } from "../../interface";
import { buildColRange } from "./buildColRange";

/**
 * Replaces the current selection with a column range between two columns.
 *
 * @param cols - All available scaffold columns.
 * @param anchorColId - The column ID of the selection anchor.
 * @param targetColId - The column ID of the target column.
 * @returns A new selection state containing only the column range.
 */
export const setColRangeSelection = <T>(
  cols: ColScaffold<T>[],
  anchorColId: string,
  targetColId: string,
): ScaffoldSelection => ({
  ...EMPTY_SCAFFOLD_SELECTION,
  selectedCols: buildColRange(cols, anchorColId, targetColId),
});
